import React from 'react';
import { Grid } from '@mui/material';
import { Logos } from '../Logos.js';

export function LogosPage() {
  return (
    <Grid container spacing={1}>
      <Logos />
    </Grid>
  );
}
